import { createFileRoute } from '@tanstack/react-router'
import { CostsPage } from '../../modules/costs/CostsPage'

export const Route = createFileRoute('/_app/maintenance-costs')({
  component: CostsPage,
})
